import React, { useMemo, useState } from 'react';
import { Modal } from 'react-bootstrap';
import KycEditModal from './KycEditModal';
import {
  KYCVerification,
  addressProofType,
  proofTypeID,
} from '../../../api-services';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import swal from 'sweetalert';
import { Country } from 'country-state-city';

const KycModal = ({ viewKyc, kycData, setviewKyc, setkycData }) => {
  const addressProofs = kycData?.address_proof || [];
  const proofs = kycData?.proof || [];
  const queryClient = useQueryClient();
  const [isEditKYC, setIsEditKYC] = useState(false);
  const [dataProof, setDataProof] = useState(null);
  const [addressProof, setAddressProof] = useState(null);
  const handleClose = () => {
    setkycData({});
    setviewKyc(false);
  };

  const handleReview = () => {
    mutateReview(kycData?.id);
  };

  const { isLoading: isLoadingReview, mutate: mutateReview } = useMutation(
    'kyc-verification',
    (payload) => KYCVerification(payload),
    {
      onSuccess: (data) => {
        swal({
          text: data?.data?.message,
          icon: 'success',
          type: 'success',
          timer: 2000,
        }).then(() => {
          queryClient.invalidateQueries('getFranceRequestedList');
          handleClose();
        });
      },
      onError: (error) => {
        swal({
          title: error?.response?.data?.message,
          type: 'danger',
          icon: 'error',
        });
      },
    },
  );

  const { data: dataAddressProofType } = useQuery(
    'address-proof-type',
    addressProofType,
    {
      select: (data) => data?.data?.data,
      onSuccess: (data) => {
        const findItem = data?.find(
          (res) => res?.id === kycData?.address_proof_type_id,
        );
        setAddressProof(findItem);
      },
    },
  );
  const { data: dataProofTypeID } = useQuery(
    ['data-proof-type', kycData?.type, kycData?.proof_type_id],
    () =>
      proofTypeID({
        type: kycData?.type || 'Personal',
      }),
    {
      select: (data) => data?.data?.data,
      onSuccess: (data) => {
        const findItem = data?.find(
          (res) => res?.id === kycData?.proof_type_id,
        );
        setDataProof(findItem);
      },
    },
  );

  const userCountry = useMemo(() => {
    const res = Country.getAllCountries()?.find(
      (res) => res?.isoCode === kycData?.user_country,
    );
    return res;
  }, [kycData?.user_country]);

  return (
    <>
      {!isEditKYC ? (
        <Modal
          size="md"
          centered
          show={viewKyc}
          onHide={() => handleClose()}
          backdrop="static"
          keyboard={false}
        >
          <form>
            <div className="modal-header ">
              <div className="icon_arrow"></div>
              <h5 className="modal-title heading heading--xs mb-0 ">
                KYC Details
              </h5>
            </div>

            <div
              className="modal-body overflow-auto "
              style={{
                maxHeight: 'calc(100vh - 200px)',
              }}
            >
              <div className="form-group">
                <label className="labelMove">Profile Type:</label>
                &nbsp;
                <small>{kycData?.type || 'N/A'}</small>
              </div>
              <div className="form-group">
                <label className="labelMove">First Name:</label>
                &nbsp;
                <small>{kycData?.first_name || 'N/A'}</small>
              </div>
              <div className="form-group">
                <label className="labelMove">Last Name:</label>
                &nbsp;
                <small>{kycData?.last_name || 'N/A'}</small>
              </div>
              {kycData?.type === 'Business' ? (
                <div className="form-group">
                  <label className="labelMove">Company Name:</label>
                  &nbsp;
                  <small>{kycData?.company_name || 'N/A'}</small>
                </div>
              ) : null}

              <div className="form-group">
                <label className="labelMove">Address:</label>
                &nbsp;
                <small>{kycData?.address || 'N/A'}</small>
              </div>
              <div className="form-group">
                <label className="labelMove">User City:</label>
                &nbsp;
                <small>{kycData?.user_city || 'N/A'}</small>
              </div>
              <div className="form-group">
                <label className="labelMove">User Country:</label>
                &nbsp;
                <small>{userCountry?.name || 'N/A'}</small>
              </div>
              {kycData?.type === 'Business' ? (
                <div>
                  <div className="form-group">
                    <label className="labelMove">
                      Company Registration Number:
                    </label>
                    &nbsp;
                    <small>{kycData?.registration_num || 'N/A'}</small>
                  </div>
                  <div className="form-group">
                    <label className="labelMove">VAT Number:</label>
                    &nbsp;
                    <small>{kycData?.vat_id || 'N/A'}</small>
                  </div>
                  <div className="form-group">
                    <label className="labelMove">TAX Number:</label>
                    &nbsp;
                    <small>{kycData?.personal_tax_id || 'N/A'}</small>
                  </div>
                </div>
              ) : null}
              <div className="form-group">
                <label className="labelMove">Postal Code:</label>
                &nbsp;
                <small>{kycData?.postal_code || 'N/A'}</small>
              </div>
              <div className="form-group input_control">
                <div className="w-100">
                  <label className="form-label">Address Proof Type:</label>

                  {kycData?.address_proof_type_id ? (
                    <select
                      className="form-control"
                      value={kycData?.address_proof_type_id}
                      disabled
                    >
                      <option>{addressProof?.attributes?.name || 'N/A'}</option>
                    </select>
                  ) : (
                    <small> N/A</small>
                  )}
                </div>
              </div>
              <div className="form-group">
                <label className="labelMove">Address Proof:</label>{' '}
                {addressProofs?.length === 0 && <small>N/A</small>}
                <div className="gutter-2 d-flex flex-wrap">
                  {addressProofs &&
                    Array.isArray(addressProofs) &&
                    addressProofs.length > 0
                    ? addressProofs.map((file, index) => {
                      return (
                        <div
                          key={index}
                          style={{
                            position: 'relative',
                            background: '#f5f5f5',
                            padding: '5px',
                            borderRadius: '5px',
                          }}
                        >
                          <img
                            src={file}
                            style={{
                              height: '8rem',
                              width: '100%',
                            }}
                          />
                        </div>
                      );
                    })
                    : null}
                </div>
              </div>
              <div className="form-group input_control">
                <div className="w-100">
                  <label className="form-label">
                    {`${kycData?.type} Proof Type:`}
                  </label>
                  {kycData?.proof_type_id ? (
                    <select className="form-control" disabled>
                      <option>{dataProof?.attributes?.name || 'N/A'}</option>
                    </select>
                  ) : (
                    <small> N/A</small>
                  )}
                </div>
              </div>
              <div className="form-group">
                <label className="labelMove">{`${kycData?.type} Proof:`}</label>{' '}
                {proofs?.length === 0 && <small>N/A</small>}
                <div className="gutter-2 d-flex flex-wrap">
                  {proofs && Array.isArray(proofs) && proofs.length > 0
                    ? proofs.map((file, index) => {
                      return (
                        <div
                          key={index}
                          style={{
                            position: 'relative',
                            background: '#f5f5f5',
                            padding: '5px',
                            borderRadius: '5px',
                          }}
                        >
                          <img
                            src={file}
                            style={{
                              height: '8rem',
                              width: '100%',
                            }}
                          />
                        </div>
                      );
                    })
                    : null}
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-danger"
                onClick={() => handleClose()}
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-warning"
                onClick={() => setIsEditKYC(true)}
              >
                Edit
              </button>
              <button
                type="button"
                className="btn btn-warning"
                disabled={isLoadingReview}
                onClick={() => handleReview()}
              >
                {kycData?.status === 'R' ? 'Under Review ' : 'Review'}
              </button>
            </div>
          </form>
        </Modal>
      ) : null}

      {isEditKYC ? (
        <KycEditModal
          viewKyc={isEditKYC}
          setviewKycEdit={setIsEditKYC}
          setviewKyc={setviewKyc}
          kycData={kycData}
          dataAddressProofType={dataAddressProofType}
          dataProofTypeID={dataProofTypeID}
        />
      ) : null}
    </>
  );
};

export default KycModal;
